import DbConfig from '../../../config/DbConfig.js'
import {rtrim} from '../../functions/Common.js'

/**
 * 搜索本地好友
 * @param {Object} custom_id
 * @param {Object} param
 * @param {Object} callback
 */
export function getSearchFansList(custom_id,param,callback){
	let db = DbConfig.connect()
	let sql = 'select cf.* from yswl_custom_friends as cf left join yswl_custom_friends_tags as cft on cf.id=cft.friend_id where'
	if(custom_id != 0){
		sql += ' cf.custom_id = '+ custom_id + 'and'
	}
	// 粉丝类别筛选
	if(param.fansType !== undefined && param.fansType !== ''){
		sql += ' cf.fans_type = "'+ param.fansType +'" and'
	}
	// 标签筛选
	if(param.tag !== undefined && param.tag !== ''){
		sql += ' cft.tag_value = "'+ param.tag +'" and'
	}
	// 昵称搜索
	if(param.keyword !== undefined && param.keyword !== ''){
		sql += ' (cf.wx_name like "%'+ param.keyword +'%" or cf.con_remark like "%'+ param.keyword +'%" or cf.mobile like "%'+ param.keyword +'%") and'
	}
	sql = rtrim(rtrim(sql,'where'),'and')
	sql += ' group by cf.id order by cf.id desc'
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			let list = []
			for(let i = 0;i < results.rows.length;i++){
				list.push(results.rows[i])
			}
			callback(list)
		})
	})
}

/**
 * 根据搜索条件，获取群列表
 * @param {Object} open_id
 * @param {Object} param
 * @param {Object} callback
 */
export function getSearchClusterList(open_id,param,callback){
	let db = DbConfig.connect()
	let sql = 'select c.*,cm.cluster_id,cm.open_id from yswl_cluster as c left join yswl_cluster_member as cm on cm.cluster_id=c.id where'
	if(open_id != ''){
		sql += ' cm.open_id = "'+ open_id + '" and'
	}
	// 昵称搜索
	if(param.keyword !== undefined && param.keyword !== ''){
		sql += ' c.cluster_name like "%'+ param.keyword +'%" and'
	}else{
		callback([])
		return
	}
	sql = rtrim(rtrim(sql,'where'),'and')
	sql += ' group by c.id order by c.id desc'
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			let list = []
			for(let i = 0;i < results.rows.length;i++){
				list.push(results.rows[i])
			}
			callback(list)
		})
	})
}

/**
 * 根据聊天记录，查下包含此聊天记录的粉丝
 * @param {Object} keyword
 * @param {Object} callback
 */
export function getFansListByRecord(keyword,callback){
	let db = DbConfig.connect()
	let sql = 'SELECT cf.id,cf.custom_id,cf.wx_name,cf.wx_photo,cf.open_id,count(*) as msg_totle FROM yswl_chat_record AS cr INNER JOIN yswl_custom_friends AS cf ON cr.friend_id = cf.id WHERE content LIKE "%'+ keyword +'%" and type in("text","program") GROUP BY cr.friend_id'
	// 昵称搜索
	if(keyword === undefined || keyword === ''){
		callback([])
		return
	}
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			let list = []
			for(let i = 0;i < results.rows.length;i++){
				list.push(results.rows[i])
			}
			callback(list)
		})
	})
}


/**
 * 根据粉丝id,关键词，获取聊天记录列表
 * @param {Object} fansId
 * @param {Object} keyword
 * @param {Object} callback
 */
export function getRecordListByFansAndkeyword(fansId,keyword,callback){
	let db = DbConfig.connect()
	let sql = 'SELECT cr.*,cf.wx_name as fans_name,cf.wx_photo as fans_photo,c.wx_name as cusotm_name,c.wx_photo as custom_photo FROM yswl_chat_record as cr inner join yswl_custom_friends as cf on cr.friend_id = cf.id inner join yswl_custom as c on cr.custom_id=c.id WHERE cr.friend_id = '+ fansId +' and cr.content like "%'+ keyword +'%" and cr.type in("text","program")'
	// 昵称搜索
	if(keyword === undefined || keyword === ''){
		callback([])
		return
	}
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			let list = []
			for(let i = 0;i < results.rows.length;i++){
				list.push(results.rows[i])
			}
			callback(list)
		})
	})
}

/**
 * 根据粉丝id,记录id，获取此id往后聊天记录列表
 * @param {Object} fansId
 * @param {Object} keyword
 * @param {Object} callback
 */
export function getRecordListByFansAndIdSort(fansId,id,sort,callback){
	let db = DbConfig.connect()
	let sql = 'SELECT cr.*,cf.wx_name as fans_name,cf.wx_photo as fans_photo,c.wx_name as cusotm_name,c.wx_photo as custom_photo FROM yswl_chat_record as cr inner join yswl_custom_friends as cf on cr.friend_id = cf.id inner join yswl_custom as c on cr.custom_id=c.id WHERE cr.friend_id = '+ fansId
	if(sort === 'asc'){
		sql += ' and cr.id >= '+ id
	}else if(sort === 'desc'){
		sql += ' and cr.id < '+ id
	}
	sql += ' limit 20'
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			let list = []
			for(let i = 0;i < results.rows.length;i++){
				list.push(results.rows[i])
			}
			callback(list)
		})
	})
}